export const ModerationFilters = {
    AwaitingDecision: { id: "awaiting_decision", text: "Awaiting decision", emoji: "🔍" },
    AutomaticallyApproved: { id: "auto_approved", text: "Automatically approved", emoji: "✅" },
    HumanApproved: { id: "human_approved", text: "Manually approved", emoji: "🕵️" },
    Rejected: { id: "rejected", text: "Manually rejected", emoji: "⛔️" },
    Warned: { id: "warned", text: "Warnings", emoji: "🚦" },
    Deleted: { id: "deleted", text: "Deleted by user", emoji: "🗑️" },
    Bookmarked: { id: "bookmarked", text: "My bookmarks", emoji: "🔖" },
};

export const ModerationFiltersDefault = [
    ModerationFilters.AwaitingDecision,
    ModerationFilters.AutomaticallyApproved,
    ModerationFilters.HumanApproved,
    ModerationFilters.Rejected,
];
